// Entry index for (Admin)User_Profile
import Mo3tiUserProfile from './UserProfile';

export default Mo3tiUserProfile;
